<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-card-title>Filtros </v-card-title>
        <v-row>
          <v-col>
            <v-switch
              v-model="bloqueadasComponente"
              label="Mostrar packs/tramos cerrados"
            >
            </v-switch>
          </v-col>
        </v-row>
        <v-row align="end">
          <v-col cols="12" sm="6">
            <date-picker
              ref="datePickerFechaIni"
              v-bind:date="fechaInicioComponente"
              v-bind:title="fechaInicioTitle"
              @actualizarFecha="actualizarFechaIni"
            ></date-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <date-picker
              ref="datePickerFechaFin"
              v-bind:date="fechaFinComponente"
              v-bind:title="fechaFinTitle"
              @actualizarFecha="actualizarFechaFin"
            ></date-picker>
          </v-col>
        </v-row>
        <v-row align="end">
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="clienteSeleccionadoComponente"
              :items="clientes"
              chips
              :loading="loadingClientes"
              :disabled="loadingClientes"
              color="blue-grey lighten-2"
              label="Cliente"
              return-object
              clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              :loading="loadingContratos"
              :disabled="loadingContratos"
              v-model="contratoSeleccionadoComponente"
              :items="contratos"
              chips
              color="blue-grey lighten-2"
              label="Contratos"
              multiple
              return-object
              clearable
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cerrarDialogFiltros">Cerrar</v-btn>
      <v-btn color="blue darken-1" text @click="aplicarFiltros">
        Aplicar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
import Datepicker from "../../components/utils/Datepicker";
export default {
  components: {
    "date-picker": Datepicker,
  },
  data() {
    return {
      fechaInicioComponente: null,
      fechaInicioTitle: "Fecha inicio",
      fechaFinComponente: null,
      fechaFinTitle: "Fecha Fin",
      clienteSeleccionadoComponente: "",
      contratoSeleccionadoComponente: [],
      bloqueadasComponente: false,
      hanCambiadoFiltros: false,
    };
  },
  methods: {
    cerrarDialogFiltros() {
      this.hanCambiadoFiltros = false;
      this.$emit("cerrarDialogFiltros");
    },
    aplicarFiltros() {
      this.$emit("actualizarBloqueadas", this.bloqueadasComponente);
      this.$emit("actualizarFechaIni", this.fechaInicioComponente);
      this.$emit("actualizarFechaFin", this.fechaFinComponente);

      this.$emit(
        "actualizarClienteSeleccionado",
        this.clienteSeleccionadoComponente
      );
      this.$emit(
        "actualizarContratoSeleccionado",
        this.contratoSeleccionadoComponente
      );
      this.$emit("aplicarFiltros", this.hanCambiadoFiltros);
      this.hanCambiadoFiltros = false;
    },
    actualizarFechaIni(val) {
      this.fechaInicioComponente = val;
      if (this.$refs.datePickerFechaIni)
        this.$refs.datePickerFechaIni.actualizarFecha(val);
    },
    actualizarFechaFin(val) {
      this.fechaFinComponente = val;
      if (this.$refs.datePickerFechaFin)
        this.$refs.datePickerFechaFin.actualizarFecha(val);
    },
    actualizarClienteSeleccionado(val) {
      this.clienteSeleccionadoComponente = val;
    },
    actualizarBloqueadas(val) {
      this.bloqueadasComponente = val;
    },
  },
  computed: {
    contratos() {
      return this.$store.getters['contratos/contratosDisponibles'];
    },
    loadingClientes() {
      return this.$store.getters.loadingClientes;
    },
    loadingContratos() {
      return this.$store.getters['contratos/loadingContratos'];
    },
    clientes() {
      return this.$store.getters.clientesDisponibles;
    },
  },
  created() {
    if (!this.contratos.length) {
      this.$store.dispatch("contratos/getContratosDisponibles", 1);
    }

    if (!this.$store.getters.clientesDisponibles.length) {
      this.$store.dispatch("getClientesDisponibles");
    }
  },
  watch: {
    fechaInicioComponente() {
      this.hanCambiadoFiltros = true;
    },
    fechaFinComponente() {
      this.hanCambiadoFiltros = true;
    },
    clienteSeleccionadoComponente() {
      this.hanCambiadoFiltros = true;
    },
    contratoSeleccionadoComponente() {
      this.hanCambiadoFiltros = true;
    },
    bloqueadasComponente() {
      this.hanCambiadoFiltros = true;
    },
  },
};
</script>
<style>
</style>